import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface CustomLayoutProps {
  children: React.ReactNode;
  title?: string;
  onBack?: () => void;
  backTo?: string;
  showHeader?: boolean;
}

export function CustomLayout({ 
  children, 
  title = "Resume Tailoring", 
  onBack, 
  backTo, 
  showHeader = true 
}: CustomLayoutProps) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else if (backTo) {
      navigate(backTo);
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="min-h-screen bg-background w-full">
      {showHeader && (
        <div className="border-b border-border-light bg-card/50 backdrop-blur-sm px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Button
                variant="outline"
                size="sm"
                onClick={handleBack}
                className="h-8 w-8 p-0"
              >
                <ArrowLeft className="h-4 w-4" />
              </Button>
              <div>
                <h1 className="text-xl font-semibold text-foreground">{title}</h1>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="flex w-full">
        {children}
      </div>
    </div>
  );
}